<template>
	<div class="">
		<login-after-head-center></login-after-head-center>		
		<div id="member" class="container home-container flex">
			<side-nav></side-nav>
			<div  class="address-manage">
				<div class="home-allTitle award-title-cg" >
				    <span>注册审核进度</span>
				</div>
				
				
				<div class="clearfix address-bg ">
				        <div class="address-box" style="height:110px">
				            <span class="address-text" >个人账户 </span>
				            <span class="address-text ">企业账户 </span>
				            <span class="address-text ">13373651217</span>
				            <span class="mgL10 ">审核状态：审核通过</span>
				            <p class="">审核原因: -</p>
				        </div>
				    </div>
							
				
			</div>	
		</div>
		<i-footer></i-footer>
		<fixed-right></fixed-right>
	</div>
</template>

<script>
	export default {

		data() {
			return {

			}
		},
		mounted() {


		},
		methods: {

		},


	}
</script>

<style scoped lang="less">

</style>
